import {Draggable} from "react-beautiful-dnd";
import React from "react";
import Colors from '../../helpers/constants/colors';

type Props = {
    uuid: string,
    index: number
}

export function DraggableComponent(props: Props) {
    const {uuid, index} = props;
    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        padding: 4,
        background: isDragging ? Colors.UNILEVER_RED : "transparent",
        display: 'table-row',
        ...draggableStyle
    });

    return (
        <Draggable
            draggableId={uuid}
            index={index}
        >
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    {...props}
                    style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                    )}
                >
                    {props.children}
                </div>
            )}
        </Draggable>
    );
}


// WEBPACK FOOTER //
// ./src/components/DragDrop/DraggableComponent.js